






import { Component, Vue } from "vue-property-decorator";

import ServiceMenuStatusExplanation from "@/components/service-status/ServiceMenuStatusExplanation.vue";

@Component({
  components: { ServiceMenuStatusExplanation },
})
export default class ServiceStatusHeader extends Vue {}
